import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authApi, guardarSesion } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      nav("/login");
      return;
    }
    (async () => {
      try {
        const r = await authApi.emergentSession(sessionId);
        if (r?.access_token) guardarSesion(r);
        // Clear hash
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        toast.success("Autenticado con Google");
        const dest = sessionStorage.getItem("aipos_post_login");
        sessionStorage.removeItem("aipos_post_login");
        nav(dest || "/admin");
      } catch (e) {
        toast.error("Error autenticando con Google");
        nav("/login");
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-sky-50 to-white">
      <div className="text-center">
        <div className="h-12 w-12 mx-auto border-4 border-sky-200 border-t-sky-500 rounded-full animate-spin" />
        <p className="mt-4 text-slate-600 font-medium">Finalizando ingreso...</p>
      </div>
    </div>
  );
}
